import { OnlyDateString } from "../../../../lib";
import { AuditItem, AuthUserOmit } from "./Audit";
import { Box, Card, Typography } from "@mui/material";

type AuditListPropsType = {
    auditList: AuditItem[];
};

export default function AuditList({ auditList }: AuditListPropsType) {
    const auditDate = OnlyDateString(auditList[0].createdAt);

    const getUserName = (user: AuthUserOmit) => {
        if (user.establishment) {
            return user.establishment.companyName;
        }
        return user.firstName + " " + user.lastName;
    };

    return (
        <Card
            variant="outlined"
            sx={{
                display: "flex",
                padding: "1.5rem",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: "2rem",
                borderRadius: "1.5rem",
                background: " #FFF",
                alignSelf: "stretch",
                /* Ombre card */
                boxShadow: "0px 4px 30px 0px #E3E6E8",
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    flexDirection: "column",
                    gap: "1rem",
                    alignSelf: "stretch",
                }}
            >
                <Typography
                    sx={{
                        color: "#023",
                        fontFamily: "Roboto",
                        fontSize: "1.125rem",
                        fontStyle: "normal",
                        fontWeight: 500,
                        lineHeight: "normal",
                    }}
                >
                    {auditDate}
                </Typography>
                {auditList.map((a: AuditItem) => {
                    return (
                        <Typography
                            key={a.id}
                            sx={{
                                color: "#046",
                                fontFamily: "Roboto",
                                fontSize: "0.875rem",
                                fontStyle: "normal",
                                fontWeight: 400,
                                lineHeight: "normal",
                            }}
                        >
                            {getUserName(a.user) + " " + a.action.name}
                        </Typography>
                    );
                })}
            </Box>
        </Card>
    );
}
